import Editor from './Editor.vue';
import utile from '../../utile';

export default {
  getComponentByConfig(config) {
    return utile.resetComponentByConfig(config, 'editor', Editor);
  },
};
